module.exports = __webpack_public_path__ + "img/btn-stripe-blue-on-light@2x.e95f2d63.png";